// components/admin/BranchManager.js - UPDATED
import React, { useState, useEffect } from 'react';
import { useAdmin } from '../context/AdminContext';

const BranchManager = ({ setMessage }) => {
    const { apiRequest } = useAdmin();
    const [branches, setBranches] = useState([]);
    const [newBranchName, setNewBranchName] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadBranches();
    }, []);

    // ✅ নতুন endpoint use করুন
    const loadBranches = async () => {
        try {
            const data = await apiRequest('/new-branches');
            setBranches(data.branches || []);
        } catch (error) {
            console.error('Load branches error:', error);
            setBranches([]);
        }
    };

    const addBranch = async (e) => {
        e.preventDefault();
        if (!newBranchName.trim()) {
            setMessage({ type: 'error', text: 'Please enter branch name' });
            return;
        }

        setLoading(true);
        try {
            // ✅ নতুন endpoint use করুন
            await apiRequest('/new-branches', {
                method: 'POST',
                body: { name: newBranchName.trim() }
            });

            setNewBranchName('');
            setMessage({ type: 'success', text: 'Branch added successfully!' });
            loadBranches();
        } catch (error) {
            setMessage({ type: 'error', text: error.message });
        } finally {
            setLoading(false);
        }
    };

    const deleteBranch = async (branchId, branchName) => {
        if (window.confirm(`Delete "${branchName}" branch?`)) {
            try {
                // ✅ নতুন endpoint use করুন
                await apiRequest(`/new-branches/${branchId}`, { method: 'DELETE' });
                setMessage({ type: 'success', text: 'Branch deleted successfully!' });
                loadBranches();
            } catch (error) {
                setMessage({ type: 'error', text: 'Error deleting branch' });
            }
        }
    };

    return (
        <div className="container-fluid">
            <div className="row mb-4">
                <div className="col-12">
                    <div className="card shadow-sm">
                        <div className="card-header bg-primary text-white">
                            <h4 className="mb-0">
                                <i className="fas fa-building me-2"></i>
                                Branch Management (NEW WORKING VERSION)
                            </h4>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Branch Form */}
            <div className="card mb-4">
                <div className="card-body">
                    <form onSubmit={addBranch} className="row g-3">
                        <div className="col-md-8">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter branch name (e.g., Dhaka, Khulna)"
                                value={newBranchName}
                                onChange={(e) => setNewBranchName(e.target.value)}
                                required
                                disabled={loading}
                            />
                        </div>
                        <div className="col-md-4">
                            <button
                                type="submit"
                                className="btn btn-success w-100"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Adding...
                                    </>
                                ) : (
                                    <>
                                        <i className="fas fa-check me-2"></i>
                                        Add Branch
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            {/* Branches List */}
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">
                        Available Branches ({branches.length})
                    </h5>

                    <div className="row">
                        {branches.map(branch => (
                            <div key={branch._id} className="col-md-3 mb-3">
                                <div className="card h-100 border-success">
                                    <div className="card-body">
                                        <h6 className="mb-2 text-capitalize">
                                            <i className="fas fa-building text-success me-2"></i>
                                            {branch.name}
                                        </h6>
                                        <button
                                            className="btn btn-sm btn-outline-danger w-100 mt-2"
                                            onClick={() => deleteBranch(branch._id, branch.name)}
                                        >
                                            <i className="fas fa-trash me-1"></i>
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {branches.length === 0 && (
                        <div className="text-center py-5">
                            <i className="fas fa-building fa-3x text-muted mb-3"></i>
                            <h5 className="text-muted">No Branches Added Yet</h5>
                            <p className="text-muted">Add your first branch using the form above</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BranchManager;